import { filter, flat, go, map } from "fxjs";
import React, { createContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";
import translation from "~/i18n";
import i18n from "~/i18n";

export const AppContext = createContext();


// @INFO content 값 -> st에서 기업정보 매핑 || st 화면에 출력하는 용도 같이 사용하고 있음

const RoundRegContext = ({ children }) => {
	const [inquiryFinalList, setInquiryFinalList] = useState([
		{ type: "TITLE", title: "", content: "", order: 0, selectOption: [], required: false },
	]);
	const [snsValueList, setSnsValueList] = useState([
		{
			checked: false,
			label: i18n.t("constant.CommonConstant.facebook"),
			value: "facebook",
			text: "",
		},
		{
			checked: false,
			label: i18n.t("constant.CommonConstant.twitter"),
			value: "twitter",
			text: "",
		},
		{
			checked: false,
			label: i18n.t("constant.CommonConstant.instagram"),
			value: "instagram",
			text: "",
		},
		{
			checked: false,
			label: i18n.t("constant.CommonConstant.linkedin"),
			value: "linkedin",
			text: "",
		},
		{
			checked: false,
			label: i18n.t("constant.CommonConstant.youtube"),
			value: "youtube",
			text: "",
		},
	]);
	const [questionFinalList, setQuestionFinalList] = useState([{ question: "", answer: "" }]);
	const [orderNum, setOrderNum] = useState(1);
	const [qOrderNum, setQOrderNum] = useState(1);
	const [registerWay, setRegisterWay] = useState("온라인 질의 작성하기");
	const [modEdit, setModEdit] = useState();
	const [modInquiry, setModInquiry] = useState([]);
	const [modQuestion, setModQuestion] = useState([]);
	const [fileList, setFileList] = useState([]);
	const [companyList, setCompanyList] = useState([]);
	const [roundStatus, setRoundStatus] = useState();

	// 내부 & 외부 심사역
	const [judgeList, setJudgeList] = useState([]); // 내부
	const [attendFilter, setAttendFilter] = useState([]); // 내부
	const [outSourcing, setOutSourcing] = useState([]); // 외부

	const inquiryAddCommon = (addData) => {
		setInquiryFinalList((prev) => [...prev, { ...addData, order: orderNum }]);
		setOrderNum(orderNum + 1);
	};

	const questionAddCommon = (addData) => {
		setQuestionFinalList((prev) => [...prev, { ...addData, order: qOrderNum }]);
		setQOrderNum(qOrderNum + 1);
	};

	const addCategory = () => {
		inquiryAddCommon({ type: "CATEGORY", title: "", selectOption: [] });
	};

	const addInquiry = () => {
		inquiryAddCommon({
			type: "SHORT",
			title: "",
			content: "",
			selectOption: [],
			required: false,
		});
	};

	const addQuestion = () => {
		questionAddCommon({ question: "", answer: "" });
	};

	const setListByTarget = (target) => {
		setInquiryFinalList(
			inquiryFinalList.map((value) => (value.order === target.order ? target : value))
		);
	};

	const handleQuestionInputChange = (index, event) => {
		const values = [...questionFinalList];
		if (event.target.id === "questionTitle" + index) {
			values[index].question = event.target.value;
		} else if (event.target.id === "questionValue" + index) {
			values[index].answer = event.target.value;
		}
		setQuestionFinalList(values);
	};

	const handleInquiryCopyFields = (orderNum) => {
		const temp = inquiryFinalList.find((d) => d.order === orderNum);
		let i = 1;
		let result = go(
			inquiryFinalList,
			map((a) => {
				if (a.order === orderNum) {
					return [a, temp];
				}
				return a;
			}),
			flat,
			map((a) => {
				return { ...a, order: i++ };
			})
		);
		setOrderNum(i);
		setInquiryFinalList(result);
	};

	const handleInquiryDelete = (orderNum) => {
		const temp = inquiryFinalList.filter((card) => card.order !== orderNum);
		let i = 0;
		temp.forEach((item) => (item.order = i++));
		setOrderNum(i);
		setInquiryFinalList(temp);
	};

	const handleQuestionCopyFields = (index) => {
		let temp = questionFinalList[index];
		let i = 1;
		let result = go(
			questionFinalList,
			map((a) => {
				if (a.order === index + 1) {
					return [a, temp];
				}
				return a;
			}),
			flat,
			map((a) => {
				return { ...a, order: i++ };
			})
		);
		setQOrderNum(i);
		setQuestionFinalList(result);
	};

	const handleQuestionRemoveFields22 = (event, index) => {
		event.preventDefault();
		// const values = [...questionFinalList];
		let i = 1;
		let result = go(
			questionFinalList,
			filter((a) => a.order !== index + 1),
			// flat,
			map((a) => {
				return { ...a, order: i++ };
			})
		);
		// values.splice(index, 1);
		setQuestionFinalList(result);
		setQOrderNum(qOrderNum - 1);
	};

	/**
	 * 드래그
	 * */

	const dragListChange = (list, dragOrderNum, endOrderNum) => {
		const temp = list.find((d) => d.order === dragOrderNum);

		let i = 0;
		let result = go(
			list,
			filter((a) => a.order !== parseInt(dragOrderNum)),
			map((a) => {
				if (parseInt(endOrderNum) === a.order) {
					if (dragOrderNum > endOrderNum) {
						return [temp, a];
					} else {
						return [a, temp];
					}
				}
				return a;
			}),
			flat,
			map((a) => {
				return { ...a, order: i++ };
			})
		);

		return result;
	};

	function changeRequired(e, orderNum) {
		setInquiryFinalList(
			inquiryFinalList.map((value) =>
				value.order === orderNum
					? { ...value, required: e.target.value === "false" }
					: value
			)
		);
	}

	function dragListChangeInquiry(dragOrderNum, endOrderNum) {
		const result = dragListChange(inquiryFinalList, dragOrderNum, endOrderNum);
		setInquiryFinalList(result);
	}

	function dragListChangeQuestion(dragOrderNum, endOrderNum) {
		let result = dragListChange(questionFinalList, dragOrderNum, endOrderNum);
		setQuestionFinalList(result);
	}

	const cardForMainTitle = inquiryFinalList[0];

	const inquiryForm = useForm({
		defaultValues: {
			inquiry: inquiryFinalList[0].title,
			inquiryDesc: inquiryFinalList[0].content,
		},
	});

	const inquiryInput = inquiryForm.watch("inquiry");
	const inquiryDescInput = inquiryForm.watch("inquiryDesc");

	useEffect(() => {
		setListByTarget({ ...cardForMainTitle, title: inquiryInput });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inquiryInput]);

	useEffect(() => {
		setListByTarget({ ...cardForMainTitle, content: inquiryDescInput });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inquiryDescInput]);

	const roundDetailInfo = useRequest("get", "vc/round/detail");

	const [searchParams, setSearchParams] = useSearchParams();

	const targetModifyIdx = searchParams.get("idx");

	useEffect(() => {
		if (targetModifyIdx) {
			const intIdx = parseInt(targetModifyIdx);
			roundDetailInfo.singleCall(intIdx, "path");
		}
	}, [targetModifyIdx]);

	useEffect(() => {
		switch (roundDetailInfo.state) {
			case API_STATE.done:
				// 라운드 수정 상태 표시
				setRoundStatus("roundEdit");
				// 내부,외부 심사, 공지사항
				setReviewContent({
					judgeList: roundDetailInfo.response.data.judge,
					noticeTitle: roundDetailInfo.response.data.round.noticeTitle,
					noticeContent: roundDetailInfo.response.data.round.noticeContent,
					noticeCheck: (roundDetailInfo.response.data.round.noticeTitle !=="" && roundDetailInfo.response.data.round.noticeContent !== ""),
					review: roundDetailInfo.response.data.round.Review
				});
				// Edit 정보,
				setModEdit(roundDetailInfo.response.data.round);
				// Inquiry 정보,
				setModInquiry(roundDetailInfo.response.data.query);
				// Question 정보
				setModQuestion(roundDetailInfo.response.data.round.Qna);
				// File 정보
				const newFileList = roundDetailInfo.response.data?.files?.map((file) => {
					return { name: file.name, path: file.path, size: Number(file.size) };
				});
				setFileList(newFileList);

				break;
			case API_STATE.error:
				console.log("error >>> ", roundDetailInfo.error);
				break;
			default:
				break;
		}
	}, [roundDetailInfo.state, roundDetailInfo.response, roundDetailInfo.error]);
	// setInquiryFinalList


	useEffect(() => {
		if (modInquiry.length > 0) {
			setInquiryFinalList(modInquiry);
			setOrderNum(modInquiry.length);
		}
	}, [modInquiry]);

	useEffect(() => {
		if (modQuestion.length > 0) {
			setQuestionFinalList(modQuestion);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modQuestion]);

	const roundRegForm = useForm({
		defaultValues: {
			applyStartDate: new Date(),
			applyEndDate: new Date().setMonth(new Date().getMonth() + 1),
		},
	});

	const [detailContent, setDetailContent] = useState("");
	const [reviewContent, setReviewContent] = useState({}); // 심사설정 > 내부,외부심사역, 공지사항
	const [externalLink, setExternalLink] = useState();
	const [nameSearch, setNameSearch] = useState();

	const [check, setCheck] = useState(false);
	const mainImg = roundRegForm.watch("sign");
	// 심사역 목록 api
	const roundJudgesListRequest = useRequest(
		"get",
		`/vc/round/member/list?name=${nameSearch || ""}`
	); // 심사역 목록

	useEffect(() => {
		roundJudgesListRequest.call();
	}, [])
	useEffect(() => {
		switch (roundJudgesListRequest.state) {
			case API_STATE.done:
				const judgeTempList = roundJudgesListRequest.response.data;
				const newData = judgeTempList.map((d, idx) => ({
					userIdx: d.idx,
					role: idx === 0 ? "심사참여" : "",
					img: d.img,
					external: false,
					email: d.id,
					name: d.name,
					id: "",
					pw: "",
				}));

				if (reviewContent && Object.keys(reviewContent)?.length > 0) {
					const defaultList = reviewContent?.judgeList?.filter(item => !item.external);
					const setData = newData.map(item => {
						const found = defaultList.find(it => it.userIdx === item.userIdx);
						return found ? { ...item, role: found.role } : item;
					});
					setJudgeList(setData);
					setAttendFilter(setData.filter(item => item.role !== ""));

				} else {
					setJudgeList(newData);
				}

				break;
			case API_STATE.error:
				console.log("얼마나 작동 error>> ", roundJudgesListRequest.error);
				break;
			default:
				break;
		}
	}, [
		roundJudgesListRequest.state,
		roundJudgesListRequest.response,
		roundJudgesListRequest.error,
		reviewContent
	]);


	function defaultModalSubmit(isUpd) {
		let temp = [...inquiryFinalList];
		let order = orderNum;
		let i = 0;


		if(!isUpd && inquiryFinalList.length <= 1) {
			// 최초 팝업 선택
			if (inquiryDefaultInfo.companyName)
				temp = defaultAdd(
					temp,
					"SHORT",
					translation.t("pages.applyFormMange.modals.companyName"),
					"name",
					order + i++,
					true,
					true
				);
			if (inquiryDefaultInfo.establishment)
				temp = defaultAdd(
					temp,
					"DATE",
					translation.t("pages.applyFormMange.modals.establishment"),
					"estDate",
					order + i++,
					true,
					true
				);
			if (inquiryDefaultInfo.address)
				temp = defaultAdd(
					temp,
					"ADDRESS",
					translation.t("pages.applyFormMange.inputComponent.applyInquriy.cardType.address"),
					"address",
					order + i++,
					true,
					true
				);
			if (inquiryDefaultInfo.businessNumber)
				temp = defaultAdd(
					temp,
					"SHORT",
					translation.t("pages.applyFormMange.modals.businessNumber"),
					"regNum",
					order + i++,
					true,
					true
				);
			if (inquiryDefaultInfo.employee)
				temp = defaultAdd(
					temp,
					"SHORT",
					translation.t("pages.applyFormMange.modals.employee"),
					"employeeNum",
					order + i++,
					true,
					true
				);
			if (inquiryDefaultInfo.homepage)
				temp = defaultAdd(
					temp,
					"SHORT",
					translation.t("pages.applyFormMange.modals.homepage"),
					"homepage",
					order + i++,
					true,
					true
				);
			if (inquiryDefaultInfo.ceo)
				temp = defaultAdd(
					temp,
					"SHORT",
					translation.t("pages.applyFormMange.modals.ceo"),
					"ceoName",
					order + i++,
					true,
					true
				);
			if (inquiryDefaultInfo.companyType)
				temp = [
					...temp,
					{
						type: "SELECT",
						title: translation.t("pages.applyFormMange.modals.companyType.title"),
						content: "type",
						order: order + i++,
						required: true,
						isCompanyData: true,
						selectOption: [
							translation.t("pages.applyFormMange.modals.companyType.selectOption1"),
							translation.t("pages.applyFormMange.modals.companyType.selectOption2"),
							translation.t("pages.applyFormMange.modals.companyType.selectOption3"),
						],
						defaultDataType: "",
					},
				];
			if (inquiryDefaultInfo.description)
				temp = defaultAdd(
					temp,
					"LONG",
					translation.t("pages.applyFormMange.modals.description"),
					"introduction",
					order + i++,
					true,
					true
				);
			if (inquiryDefaultInfo.sales)
				temp = defaultAdd(
					temp,
					"SHORT",
					translation.t("pages.applyFormMange.modals.sales"),
					"",
					order + i++,
					true,
					true
				);
			if (inquiryDefaultInfo.productName)
				temp = defaultAdd(
					temp,
					"SHORT",
					translation.t("pages.applyFormMange.modals.product"),
					"",
					order + i++,
					true,
					true
				);
			if (inquiryDefaultInfo.industry)
				temp = defaultAdd(
					temp,
					"MULTISELECT",
					translation.t("pages.applyFormMange.modals.industry"),
					"fields",
					order + i++,
					true,
					true
				);
			if (inquiryDefaultInfo.productDescription)
				temp = defaultAdd(
					temp,
					"LONG",
					translation.t("pages.applyFormMange.modals.productDescription"),
					"",
					order + i++,
					true,
					true
				);
			if (inquiryDefaultInfo.differentiation)
				temp = defaultAdd(
					temp,
					"LONG",
					translation.t("pages.applyFormMange.modals.differentiation"),
					"",
					order + i++,
					true,
					true
				);
			if (inquiryDefaultInfo.keywords)
				temp = defaultAdd(
					temp,
					"TAG",
					translation.t("pages.applyFormMange.modals.keywords"),
					"",
					order + i++,
					true,
					true
				);
		}

		if (inquiryDefaultInfo.attach)
			temp = defaultAdd(
				temp,
				"FILE",
				"첨부파일",
				"", // attach
				order + i++,
				false,
				false,
				"attach"
			);
		if (inquiryDefaultInfo.nation)
			temp = defaultAdd(
				temp,
				"SHORT",
				translation.t("pages.applyFormMange.modals.nation"),
				"", // country
				order + i++,
				false,
				false,
				"nation"

			);
		if (inquiryDefaultInfo.stocks)
			temp = [
				...temp,
				{
					type: "ALTERNATIVE",
					title: translation.t("pages.applyFormMange.modals.stocks.title"),
					content: "", // listed
					order: order + i++,
					selectOption: [
						{
							title: translation.t(
								"pages.applyFormMange.modals.stocks.selectOption1"
							),
						},
						{
							title: translation.t(
								"pages.applyFormMange.modals.stocks.selectOption2"
							),
						},
					],
					required: false,
					defaultDataType: "stocks"
				},
			];

		setInquiryDefaultInfo({
			...inquiryDefaultInfo,
			companyName: true, //기업명
			businessNumber: true, //사업자등록번호,
			ceo: true, // 대표
			sales: true, // 매출
			industry: true, // 산업분야
			differentiation: true, // 차별성
			establishment: true, // 설립일자
			employee: true, // 직원수
			companyType: true, // 기업구분
			// nation: true, // 국가
			// stocks: true, // 상장구분
			keywords: true, // 키워드
			address: true, // 주소
			homepage: true, // 홈페이지
			description: true, // 기업개요
			productName: true, // 제품명
			productDescription: true, // 제품한줄소개
		});
		setOrderNum(order + i);

		if(isUpd) {
			const updateData = [];
			if(inquiryDefaultInfo.nation) {
				updateData.push(temp.filter(item => (item.defaultDataType && item.defaultDataType === "nation"))[0])
			}
			if(inquiryDefaultInfo.attach) {
				updateData.push(temp.filter(item => (item.defaultDataType && item.defaultDataType === "attach"))[0])
			}
			if(inquiryDefaultInfo.stocks) {
				updateData.push(temp.filter(item => (item.defaultDataType && item.defaultDataType === "stocks"))[0])
			}
			setInquiryFinalList([
				...inquiryFinalList.filter(item => (item?.defaultDataType !== "nation" && item?.defaultDataType !== "attach" && item?.defaultDataType !== "stocks" )),
				...updateData
			]);

			const test = [...inquiryFinalList.filter(item => (item?.defaultDataType !== "nation" && item?.defaultDataType !== "attach" && item?.defaultDataType !== "stocks" )),
				...updateData]

		} else {
			setInquiryFinalList(temp);
		}
	}

	function defaultAdd(temp, type = "SHORT", title, content, orderNum, required, isCompanyData, defaultDataType="") {
		return [
			...temp,
			{
				type: type,
				order: orderNum,
				selectOption: [],
				title: title,
				content: content,
				required: required,
				isCompanyData: isCompanyData ?? false,
				defaultDataType: defaultDataType,
			},
		];
	}

	const [inquiryDefaultInfo, setInquiryDefaultInfo] = useState({
		companyName: true, //기업명
		businessNumber: true, //사업자등록번호,
		ceo: true, // 대표
		sales: true, // 매출
		industry: true, // 산업분야
		differentiation: true, // 차별성
		establishment: true, // 설립일자
		employee: true, // 직원수
		companyType: true, // 기업구분
		keywords: true, // 키워드
		address: true, // 주소
		homepage: true, // 홈페이지
		description: true, // 기업개요
		productName: true, // 제품명
		productDescription: true, // 제품한줄소개
		attach: false, // 첨부파일
		nation: false, // 국가
		stocks: false, // 상장구분
	});


	useEffect(() => {
		if (roundStatus === "roundEdit") {
			roundRegForm.setValue("roundTitle", modEdit.title);
			setDetailContent(modEdit.content);
			roundRegForm.setValue("introduction", modEdit.description);
			roundRegForm.setValue("sign", modEdit.img);
			roundRegForm.setValue("applyStartDate", new Date(modEdit.startDate));
			roundRegForm.setValue("applyEndDate", new Date(modEdit.endDate));
			roundRegForm.setValue("way", modEdit.applyMethod);
			roundRegForm.setValue("place", modEdit.place);
			roundRegForm.setValue("zipCode", modEdit.zipCode);
			roundRegForm.setValue("address", modEdit.address);
			roundRegForm.setValue("addressDetail", modEdit.addressDetail);
			roundRegForm.setValue("hostName", modEdit.managerName);
			roundRegForm.setValue("hostEmail", modEdit.managerEmail);
			// roundRegForm.setValue("evaluateTemplate", modEdit.Review.title);
			setExternalLink(modEdit.survey);
			const newSnsList = snsValueList.map((item) => {
				return { ...item, text: modEdit[item.value], checked: !!modEdit[item.value] };
			});
			setSnsValueList(newSnsList);
			// survey
			if (modEdit.Qna.length > 0) {
				setCheck(true);
			}
		}
	}, [modEdit]);

	return (
		<AppContext.Provider
			value={{
				addCategory,
				addInquiry,
				list: inquiryFinalList,
				setList: setInquiryFinalList,
				inquiryForm,
				setListByTarget,
				dragListChange: dragListChangeInquiry,
				addQuestion,
				qList: questionFinalList,
				dragListChangeQuestion,
				handleQuestionInputChange,
				handleQuestionCopyFields,
				handleQuestionRemoveFields: handleQuestionRemoveFields22,
				handleInquiryCopyFields,
				handleInquiryDelete,
				roundRegForm,
				detailContent,
				setDetailContent,
				mainImg,
				externalLink,
				setExternalLink,
				check,
				setCheck,
				inquiryDefaultInfo,
				setInquiryDefaultInfo,
				defaultModalSubmit,
				changeRequired,
				cardForMainTitle,
				registerWay,
				setRegisterWay,
				inquiryInput,
				modEdit,
				setModEdit,
				modInquiry,
				setModInquiry,
				modQuestion,
				setModQuestion,
				fileList,
				setFileList,
				roundStatus,
				setRoundStatus,
				targetModifyIdx,
				companyList,
				setCompanyList,
				snsValueList,
				setSnsValueList,
				reviewContent,
				judgeList, setJudgeList,
				attendFilter, setAttendFilter,
				outSourcing, setOutSourcing,
			}}
		>
			{children}
		</AppContext.Provider>
	);
};

export default RoundRegContext;
